import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetAssetCategoriesResponse } from '@/api/handlers/resources/fixedAssets/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { FixedAssetQueryKeys } from './fixedAssetQueryKeys';

/**
 * The asset categories and their account mapping. Categories change rarely and
 * every asset row needs one, so this is cached generously.
 */
export const useAssetCategoriesQuery = () => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetAssetCategoriesResponse>>({
        queryKey: FixedAssetQueryKeys.categories(),
        queryFn: () => apiClient.fixedAssets.getCategories(),
        staleTime: 5 * 60_000,
        gcTime: Infinity,
    });
};
